import { Modal, Radio, Table, Tabs, Tag } from 'antd';
import styled, { css } from 'styled-components';
// import Color from 'export constants/color';
// import { Radio } from 'antd';
export const Container = styled.div`
  padding: 20px;
  background-color: #f8f9fa;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Section = styled.div`
  width: 100%;
  margin-bottom: 30px;
  background-color: #ffffff;
  padding: 20px;
  border-radius: 15px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 16px 24px rgba(0, 0, 0, 0.15);
  }
`;

export const Header = styled.h2`
  margin-bottom: 20px;
  color: #636e72;
  font-weight: 700;
  font-size: 1.75rem;
  text-align: center;
  letter-spacing: 1px;
`;

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  width: 100%;
  gap: 30px;
`;

export const StatusLabel = styled.label`
  margin-right: 10px;
  font-size: 1rem;
  color: #636e72;
  font-weight: 500;
`;

export const StatusSelect = styled.select`
  width: 100%;
  max-width: 320px;
  padding: 10px 16px;
  border: 1px solid #c8e6e0;
  border-radius: 10px;
  background-color: #f4fcfa;
  color: #004d40;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.3s ease;
  appearance: none;

  &:hover {
    background-color: #e9f9f6;
    border-color: #00b894;
  }

  &:focus {
    border-color: #0073e6;
    box-shadow: 0 0 0 3px rgba(0, 179, 159, 0.15);
    outline: none;
  }
`;

/* Base Button Style */
export const PastelButton = styled.button`
  background: linear-gradient(to right, #00b894, #0073e6);
  color: white;
  padding: 10px 24px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 600;
  box-shadow: 0 6px 20px rgba(0, 185, 148, 0.2);
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(to right, #00a982, #0060c0);
    transform: translateY(-2px);
    box-shadow: 0 10px 24px rgba(0, 185, 148, 0.3);
  }

  &:active {
    transform: scale(0.98);
  }

  &:disabled {
    background: #dfe6e9;
    color: #999;
    cursor: not-allowed;
    box-shadow: none;
  }
`;

/* Save Button with radial hover */
export const SaveButton = styled(PastelButton)`
  background: linear-gradient(to right, #009688, #4dd0e1);
  position: relative;
  overflow: hidden;

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 300%;
    height: 300%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.3) 0%, transparent 70%);
    transform: translate(-50%, -50%);
    transition: all 0.5s ease;
    pointer-events: none;
  }

  &:hover:after {
    width: 0;
    height: 0;
  }

  ${props =>
    props.disabled &&
    css`
      background: #d0d8dc !important;
      color: #888 !important;
      cursor: not-allowed !important;
      box-shadow: none !important;
    `}
`;

/* Approve Button – Soft green */
export const ApproveButton = styled(PastelButton)`
  background: linear-gradient(to right, #c1f3ec, #b2f7ef);
  color: #004d40;

  &:hover {
    background: linear-gradient(to right, #a8e3d8, #aee6e3);
    box-shadow: 0 8px 20px rgba(0, 185, 148, 0.15);
  }
`;

// ปุ่ม Not Approve
export const NotApproveButton = styled(PastelButton)`
  background-color: #f8d7da; /* สีพาสเทลอ่อนสำหรับปุ่ม Not Approve */
  color: #555555;

  &:hover {
    background-color: #efc4c6; /* สีที่เข้มขึ้นเมื่อ hover */
  }
`;

export const DetailButton = styled.button`
  background-color: #e0f7fa; /* สีพาสเทลอ่อน */
  color: #006064;
  padding: 10px 20px;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  font-size: 1rem;
  display: flex;
  align-items: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease, transform 0.3s ease;

  &:hover {
    background-color: #b2ebf2; /* สีที่เข้มขึ้นเมื่อ hover */
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(1px);
  }

  svg {
    margin-right: 10px;
  }
`;

// ตาราง Dealer
export const DealerTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 16px;
  overflow: hidden;
  background-color: #ffffff;
  box-shadow: 0 10px 30px rgba(0, 185, 148, 0.1);
  font-family: 'Inter', 'Segoe UI', sans-serif;
  margin: 24px 0;
`;

// ส่วนหัวของตาราง
export const TableHeader = styled.th`
  padding: 16px;
  /* background: linear-gradient(to right, #00b894, #0073e6); */
  background: #00b894;
  color: #ffffff;
  text-align: center;
  font-weight: 600;
  letter-spacing: 0.5px;
  font-size: 15px;
  border-bottom: 2px solid #e0f2f1;
  text-transform: uppercase;
  transition: background-color 0.3s;

  &:hover {
    background-color: #00917a;
    cursor: pointer;
  }
`;

// แถวข้อมูล
export const TableRow = styled.tr`
  transition: background-color 0.3s ease, box-shadow 0.3s ease;

  &:nth-child(even) {
    background-color: #f9fdfd;
  }

  &:hover {
    background-color: #e3fdfc;
    box-shadow: 0 6px 16px rgba(0, 185, 148, 0.08);
  }
`;

// ช่องข้อมูล
export const TableCell = styled.td`
  padding: 14px 16px;
  border-bottom: 1px solid #edf2f7;
  text-align: center;
  color: #2d3436;
  font-size: 14px;
  background-color: inherit;

  &:hover {
    color: #0073e6;
  }
`;

// หัวตาราง (caption)
export const TableCaption = styled.caption`
  caption-side: top;
  padding: 16px;
  font-size: 18px;
  font-weight: 700;
  color: #0073e6;
  background-color: #e8fafe;
  border-radius: 16px 16px 0 0;
  letter-spacing: 0.8px;
`;

// กล่อง Dropdown
export const DropdownContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
  gap: 16px;
`;

// ช่องค้นหาใน dropdown
export const DropdownInput = styled.input`
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #d0e3e2;
  border-radius: 8px;
  background-color: #f8fcfb;
  color: #34495e;
  font-size: 1rem;
  box-shadow: 0 2px 10px rgba(0, 185, 148, 0.08);
  transition: border-color 0.3s ease;

  &:focus {
    border-color: #00b894;
    outline: none;
  }
`;

// รายการใน dropdown
export const DropdownList = styled.ul`
  position: absolute;
  width: 100%;
  max-height: 160px;
  overflow-y: auto;
  background-color: #ffffff;
  border: 1px solid #dfe6e9;
  border-radius: 8px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.12);
  margin: 0;
  padding: 0;
  list-style: none;
  z-index: 999;
`;

export const DropdownListItem = styled.li`
  padding: 12px 16px;
  cursor: pointer;
  transition: background-color 0.25s ease;

  &:hover {
    background-color: #e0f7f5;
  }
`;

// ปุ่มลงทะเบียน
export const RegisterButtton = styled.button`
  background: linear-gradient(to right, #00b894, #0073e6);
  color: #ffffff;
  padding: 10px 22px;
  border: none;
  border-radius: 30px;
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
  box-shadow: 0 6px 18px rgba(0, 185, 148, 0.2);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 185, 148, 0.3);
  }

  &:active {
    transform: translateY(1px);
  }
`;

// ป้ายสถานะ
export const StyledTag = styled(Tag)`
  font-size: 0.95rem;
  font-weight: 600;
  padding: 0.4rem 1.5rem;
  border-radius: 24px;
  display: inline-block;
  letter-spacing: 0.05em;
  transition: all 0.3s ease;
  box-shadow: 0 4px 10px rgba(0, 185, 148, 0.1);

  &.wait {
    background: linear-gradient(135deg, #fff5b7, #ffec80);
    color: #997300;
    border: none;
  }

  &.approve {
    background: linear-gradient(135deg, #d2f8d2, #b2f7ef);
    color: #007e6a;
    border: none;
  }

  &.not-approve {
    background: linear-gradient(135deg, #ffcdd2, #ffb3b3);
    color: #c62828;
    border: none;
  }

  &.default {
    background: linear-gradient(135deg, #e0e0e0, #cccccc);
    color: #555;
    border: none;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
  }
`;

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 20px;
    padding: 20px;
  }

  .ant-modal-header {
    border-bottom: none;
  }

  .ant-modal-title {
    font-size: 1.5rem;
    color: #006064;
  }

  .ant-modal-body {
    font-size: 1rem;
    color: #333333;
  }

  .ant-modal-footer {
    display: flex;
    justify-content: center;
  }

  .ant-btn {
    background-color: #e0f7fa;
    color: #006064 !important;
    border: none;
    border-radius: 20px;
    padding: 5px 15px;
    width: 120px;
    height: 44px;
    font-size: 1rem;
    cursor: pointer;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1) !important;
    transition: background-color 0.3s ease, transform 0.3s ease;

    &:hover {
      background-color: #b2ebf2 !important;
      transform: translateY(-2px);
    }

    &:focus {
      background-color: #b2ebf2;
      transform: translateY(-2px);
    }

    &:active {
      transform: translateY(1px);
    }
  }
`;

export const StyledTabsDealer = styled(Tabs)`
  .ant-tabs-nav {
    margin-bottom: 24px;
  }

  .ant-tabs-tab {
    padding: 8px 8px;
    font-size: 1rem;
    color: #000000;
    transition: all 0.3s ease;
    background-color: #e5e5e5;
    border-radius: 10px;
    margin: 0 1px; /* Adjusted margin to reduce spacing */
  }

  .ant-tabs-tab:hover {
    color: #ffffff !important;
    background-color: #0f3e59 !important;
  }

  .ant-tabs-tab-active {
    background-color: #0f3e59 !important;
    color: #ffffff !important;
  }

  /* .ant-tabs-tab-btn {
    color: #000000 !important;
    transition: color 0.3s ease;
  } */

  .ant-tabs-ink-bar {
    background-color: #0f3e59;
    border-radius: 10px;
  }

  :where(.css-dev-only-do-not-override-pr0fja).ant-tabs .ant-tabs-tab + .ant-tabs-tab {
    margin: 0 !important; /* Added rule to set margin to 0 */
  }
`;

export const StyledInDetailTableDealer = styled(Table)`
  margin-top: -43px;
  .ant-table-thead > tr > th {
    background-color: #e0f7fa;
    color: #006064;
    font-size: 1.1rem;
    text-align: center;
    padding: 12px;
    border-bottom: 2px solid #b2ebf2;
    box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.1);
    transition: background-color 0.3s ease, color 0.3s ease;
  }

  .ant-table-tbody > tr > td {
    padding: 16px;
    font-size: 1rem;
    text-align: center;
    transition: background-color 0.3s ease, box-shadow 0.3s ease, color 0.3s ease;
    border-bottom: 1px solid #e0f7fa;
  }

  .ant-table-tbody > tr:hover > td {
    background-color: #f0fdfd;
    color: #004d40;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

  .ant-table {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    margin: 20px 0;
  }

  .ant-input {
    border-radius: 10px;
    padding: 5px;
    border: 1px solid #314143;
    box-shadow: 0 0 0 2px rgba(0, 188, 212, 0.1);
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
  }

  .ant-input:focus {
    border-color: #b2ebf2;
    box-shadow: 0 0 0 2px rgba(0, 188, 212, 0.2);
  }

  /* เพิ่มการปรับแต่งเพิ่มเติม */
  .ant-table-pagination.ant-pagination {
    margin: 16px 0;
  }

  .ant-table-pagination.ant-pagination .ant-pagination-item {
    border-radius: 5px;
    border: 1px solid #e0f7fa;
    color: #006064;
    transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;
  }

  .ant-table-pagination.ant-pagination .ant-pagination-item-active {
    background-color: #e0f7fa;
    border-color: #b2ebf2;
    color: #004d40;
  }

  .ant-table-pagination.ant-pagination .ant-pagination-item:hover {
    background-color: #b2ebf2;
    border-color: #80deea;
    color: #004d40;
  }

  .ant-table-pagination.ant-pagination .ant-pagination-prev,
  .ant-table-pagination.ant-pagination .ant-pagination-next {
    border-radius: 50%;
    border: 1px solid #e0f7fa;
    color: #006064;
    transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;
  }

  .ant-table-pagination.ant-pagination .ant-pagination-prev:hover,
  .ant-table-pagination.ant-pagination .ant-pagination-next:hover {
    background-color: #b2ebf2;
    border-color: #80deea;
    color: #004d40;
  }
`;
// Define refined pastel colors with gradients
const refinedPastelColors = {
  background: 'linear-gradient(145deg, #f5f7fa, #e0eafc)',
  border: '#cfd8dc',
  selectedBackground: 'linear-gradient(145deg, #b2dfdb, #a7ffeb)',
  selectedBorder: '#80cbc4',
  textColor: '#37474f',
  hoverBackground: 'linear-gradient(145deg, #e0f2f1, #b2ebf2)',
  hoverBorder: '#80cbc4',
  focusShadow: 'rgba(128, 203, 196, 0.7)',
};

// Styled components for Radio Group and Radio Button
// กลุ่ม Radio Group แนวนอน
export const StyledRadioGroup = styled(Radio.Group)`
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
`;

// ปุ่ม Radio สไตล์หรูหรา
export const StyledRadioButton = styled(Radio.Button)`
  background: #f7fafd;
  border: 2px solid #cce7f6;
  color: #0073e6;
  padding: 12px 28px;
  border-radius: 32px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-align: center;
  height: 48px;
  transition: all 0.3s ease;
  box-shadow: 0 3px 10px rgba(0, 115, 230, 0.08);
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #e6f4ff;
    border-color: #91d5ff;
    color: #0073e6;
  }

  &:active {
    transform: scale(0.98);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(0, 115, 230, 0.2);
  }

  &.ant-radio-button-wrapper-checked {
    background: linear-gradient(to right, #00b894, #0073e6);
    border-color: transparent;
    color: #ffffff;
    box-shadow: 0 6px 18px rgba(0, 115, 230, 0.25);
  }

  &.ant-radio-button-wrapper-checked:hover {
    background: linear-gradient(to right, #00a37a, #0050b3);
    color: #ffffff;
  }
`;
export const PastelRadioGroup = styled(Radio.Group)`
  margin-left: 10px;
  && .ant-radio-wrapper {
    margin-right: 10px;
    background-color: #ffffff; // Pristine white for a bright, clean look
    border-radius: 25px; // More pronounced rounded corners for a smoother pill-like appearance
    padding: 6px 24px; // Increased padding for more space and comfort
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.12); // A slightly deeper shadow for more depth and presence
  }

  && .ant-radio-wrapper .ant-radio-inner {
    border-color: #9dbf9e; // A more vivid, leafy green for a striking yet calming edge
    background-image: linear-gradient(#ffffff, #ffffff), radial-gradient(circle at center, #d4e9e2, #86c8bc);
    background-origin: border-box;
    background-clip: content-box, border-box;
  }

  && .ant-radio-wrapper .ant-radio + span {
    color: #568d67; // A deeper green, ensuring clarity and visibility while maintaining softness
  }

  && .ant-radio-wrapper:hover .ant-radio-inner,
  && .ant-radio-wrapper-focused .ant-radio-inner {
    border-color: #c7e6d7; // A richer turquoise for a distinctive hover and focus effect
    background-color: #bfd9d3; // A richer mint green for a noticeable interaction cue
  }

  && .ant-radio-wrapper:hover .ant-radio-inner:after,
  && .ant-radio-wrapper-focused .ant-radio-inner:after {
    background-color: #bfd9d3; // Consistent with the richer hover and focus background
  }

  && .ant-radio-wrapper-checked .ant-radio-inner {
    border-color: #86c8bc; // Checked state border in a vibrant sea green
    background-color: #86c8bc; // Checked state background in the same vibrant sea green
    background-image: linear-gradient(#86c8bc, #86c8bc), radial-gradient(circle at center, #86c8bc, #d4e9e2);
    box-shadow: 0 0 0 1px rgba(134, 200, 188, 0.5), 0 0 10px 4px rgba(134, 200, 188, 0.6); // An enhanced glow for a luxurious feel
  }

  && .ant-radio-wrapper-checked .ant-radio-inner:after {
    background-color: #86c8bc; // Checked state inner dot in a lighter mint green for a gentle contrast
  }
`;
